angular.module('Mineler').run(['$templateCache', function($templateCache) {
  $templateCache.put('map/panels/my-work/my-work.tpl.html',
    '<div ng-controller="MyWorkCtrl as myWork" class="map-panel-controller">\n' +
    '  <div id="map-panel-my-work-container" class="map-panel map-primary-panel" ng-swipe-left="myWork.closePanel()" ng-swipe-disable-mouse>\n' +
    '    <div class="row map-panel-heading">\n' +
    '      <div class="small-2 columns">\n' +
    '        <a class="arrow-back" ng-click="myWork.closePanel()">\n' +
    '          <i class="fa fa-angle-double-left"></i>\n' +
    '        </a>\n' +
    '      </div>\n' +
    '      <div class="small-13 columns">\n' +
    '        <ul>\n' +
    '          <li class="cursor-pointer" ng-class="{\'panel-heading-active\': myWork.tab===\'myBids\'}"\n' +
    '              ng-click="myWork.openTab(\'myBids\');">My Bids\n' +
    '          </li>\n' +
    '          <li class="cursor-pointer" ng-class="{\'panel-heading-active\': myWork.tab===\'placedWork\'}"\n' +
    '              ng-click="myWork.openTab(\'placedWork\');">Placed Work\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="map-primary-panel-content" ng-show="myWork.tab === \'myBids\'" ng-include="\'map/panels/my-work/my-work-tab-my-bids.tpl.html\'">\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="map-primary-panel-content" ng-show="myWork.tab === \'placedWork\'" ng-include="\'map/panels/my-work/my-work-tab-placed-work.tpl.html\'">\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '  <div id="map-panel-work-actions" class="map-secondary-panel-container"></div>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);
